import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBoxRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 20 21",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9.25 10.917 4 8v5.297c0 .453.247.872.644 1.094L9.25 16.95v-6.034ZM6.544 5.504 4.572 6.601l5.431 3.016 1.941-1.079-5.334-3-.063-.034h-.003Zm1.54-.856 5.398 3.034 1.953-1.084-4.825-2.681a1.255 1.255 0 0 0-1.216 0l-1.313.734.004-.003Zm2.666 6.269v6.034l4.607-2.56A1.25 1.25 0 0 0 16 13.298v-5.3l-5.25 2.915v.004Zm.585 7.425a2.746 2.746 0 0 1-2.672 0l-4.75-2.638A2.752 2.752 0 0 1 2.5 13.298v-5.79a2.5 2.5 0 0 1 1.285-2.185L8.663 2.61a2.746 2.746 0 0 1 2.672 0l4.878 2.71A2.502 2.502 0 0 1 17.5 7.507v5.794c0 1-.54 1.919-1.415 2.403l-4.75 2.638Z" })
});
export default SvgBoxRegularIcon;
